import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import i18n from '../../util/i18n'
import LanguageSelector from './LanguageSelector'
import { updateUserLanguage } from '../user/userSlice'
import isMobileView from '../../util/MobileView'

export const LanguageSelectionManager = ({ dispatch, userObj, t }) => {
  const navigate = useNavigate()
  const [selectedLanguage, setSelectedLanguage] = useState(userObj.preferredLanguage ?? '')
  const [setAlertVisible] = useState(false)
  const [setAlertMessage] = useState('')

  const handleLanguageChange = (event) => setSelectedLanguage(event.target.value)

  const isMobile = isMobileView()
  const languageOptions = {
    'en-US': t('language-english'),
    'es-ES': t('language-spanish'),
    'ja-JP': t('language-japanese'),
    'ko-KR': t('language-korean'),
    'nl-NL': t('language-dutch'),
    'de-DE': t('language-german'),
    'pt-PT': t('language-portuguese'),
    'fr-FR': t('language-french')
  }

  const handleLanguageSelectorError = (errorMessage) => {
    setAlertMessage(errorMessage)
    setAlertVisible(true)
  }

  const handleSave = () => {
    const languageUpdatePayload = { preferredLanguage: selectedLanguage }

    dispatch(updateUserLanguage(languageUpdatePayload))
      .unwrap()
      .then(() => {
        i18n.changeLanguage(selectedLanguage)
        navigate('/account')
      })
      .catch(() => {
        handleLanguageSelectorError(t('error-saveFailed'))
      })
  }

  const languageSelectorComponent = (
    <LanguageSelector
      label={t('pref-lang-header')}
      value={selectedLanguage}
      onChange={handleLanguageChange}
      onSave={handleSave}
      onCancel={() => ''}
      saveButtonText={t('button-save-changes')}
      cancelButtonText={t('button-cancel')}
      buttonStyles={{
        saveButton: 'cta-red-oval-edit-profile',
        cancelButton: 'cta-grey-oval'
      }}
      languageOptions={languageOptions}
      onError={handleLanguageSelectorError}
      isMobile={isMobile}
    />
  )

  return {
    languageSelectorComponent,
    setAlertVisible,
    languageOptions
  }
}
